<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="boxes" class="mr-2"></b-icon>Mahsulot ombor hisoboti</h2>
        </div>
        <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
          <b-icon icon="file-earmark-excel"></b-icon> Excel
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Holat sanasi</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>Filter</label>
          <select v-model="stockFilter">
            <option value="all">Barchasi</option>
            <option value="low">Kam qoldiq</option>
            <option value="empty">Tugaganlar</option>
          </select>
        </div>
        <div class="rp-filter"><label>Qidiruv</label><input type="search" v-model="search" placeholder="Mahsulot..."></div>
        <div class="rp-filter"><label>&nbsp;</label><button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button></div>
      </div>

      <div class="rp-summary rp-summary-5">
        <div class="rp-card rp-c-1"><div class="rp-card-label">MAHSULOT TURI</div><div class="rp-card-value">{{ filtered.length }}</div></div>
        <div class="rp-card rp-c-6"><div class="rp-card-label">KAM QOLDIQ</div><div class="rp-card-value rp-orange">{{ lowCount }}</div></div>
        <div class="rp-card rp-c-3"><div class="rp-card-label">JAMI TANNARX</div><div class="rp-card-value rp-red">{{ fmt(totals.total_cost) }}</div></div>
        <div class="rp-card rp-c-2"><div class="rp-card-label">JAMI CHAKANA NARX</div><div class="rp-card-value rp-green">{{ fmt(totals.total_chakana) }}</div></div>
        <div class="rp-card rp-c-4"><div class="rp-card-label">JAMI OPTOM NARX</div><div class="rp-card-value rp-blue">{{ fmt(totals.total_optom) }}</div></div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="list-ul"></b-icon> Ombor qoldig'i</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>#</th><th>Mahsulot</th>
                <th class="t-center">Qoldiq</th>
                <th class="t-right">Tannarx (1 dona)</th>
                <th class="t-right">Jami tannarx</th>
                <th class="t-right">Chakana</th>
                <th class="t-right">Optom</th>
                <th class="t-right">Jami chakana</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in filtered" :key="r.product_id" :class="{ 'rp-low-row': r.low_stock }">
                <td><span class="rp-num">{{ i + 1 }}</span></td>
                <td class="rp-strong">
                  {{ r.product_name || r.short_name }}
                  <span v-if="r.low_stock" class="rp-badge rp-badge-warn ml-1">Kam</span>
                </td>
                <td class="t-center"><b>{{ fmt(r.stock_balance) }}</b></td>
                <td class="t-right">{{ fmt(r.last_cost) }}</td>
                <td class="t-right rp-red">{{ fmt(r.total_cost) }}</td>
                <td class="t-right">{{ fmt(r.last_chakana) }}</td>
                <td class="t-right">{{ fmt(r.last_optom) }}</td>
                <td class="t-right rp-green rp-strong">{{ fmt(r.total_chakana) }}</td>
              </tr>
              <tr v-if="!loading && filtered.length === 0"><td colspan="8" class="rp-empty">Mahsulot topilmadi</td></tr>
            </tbody>
            <tfoot v-if="filtered.length > 0">
              <tr>
                <th colspan="4" class="t-right">JAMI:</th>
                <th class="t-right">{{ fmt(totals.total_cost) }}</th>
                <th></th><th></th>
                <th class="t-right">{{ fmt(totals.total_chakana) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    return {
      date2: this.todayStr(),
      sklad_id: null, skladList: [], items: [], lowCount: 0,
      totals: { total_count: 0, total_cost: 0, total_chakana: 0, total_optom: 0 },
      stockFilter: 'all', search: '', loading: false,
    };
  },
  computed: {
    filtered() {
      let arr = this.items;
      if (this.stockFilter === 'low') arr = arr.filter(r => r.low_stock);
      if (this.stockFilter === 'empty') arr = arr.filter(r => parseFloat(r.stock_balance) <= 0);
      if (this.search && this.search.length >= 2) {
        const q = this.search.toLowerCase();
        arr = arr.filter(r => (r.product_name && r.product_name.toLowerCase().includes(q)) || (r.short_name && r.short_name.toLowerCase().includes(q)));
      }
      return arr;
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    todayStr() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/product-stock/', {
          datetime1: this.toUnix(this.date2, false),
          datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        this.items = r.data.items || [];
        this.totals = r.data.totals || this.totals;
        this.lowCount = r.data.low_count || 0;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    exportCsv() {
      const h = ['Mahsulot', 'Qoldiq', 'Tannarx', 'Jami tannarx', 'Chakana', 'Optom', 'Jami chakana'];
      const rows = this.filtered.map(r => [r.product_name||r.short_name, r.stock_balance, r.last_cost, r.total_cost, r.last_chakana, r.last_optom, r.total_chakana]);
      const csv = [h, ...rows].map(x => x.map(c => `"${String(c||'').replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿"+csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `ombor_${this.date2}.csv`; a.click();
    }
  }
};
</script>
